import { render } from "./ArtDetail.vue?vue&type=template&id=7a577985"
import script from "./ArtDetail.vue?vue&type=script&lang=js"
export * from "./ArtDetail.vue?vue&type=script&lang=js"

import "./ArtDetail.vue?vue&type=style&index=0&id=7a577985&lang=css"

import exportComponent from "D:\\project\\idbrand\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__